interface ReadTarget {
	id: string
	isRead?: boolean
}

const MAX_IDS_PER_CALL = 500

/** What U does: any unread target marks them all read, otherwise all unread. Checked threads win over the cursor. */
export function readToggle(
	checked: ReadTarget[],
	cursor: ReadTarget | undefined,
): Array<{ ids: string[]; isRead: boolean }> {
	const targets = checked.length > 0 ? checked : cursor ? [cursor] : []
	if (targets.length === 0) return []
	const isRead = targets.some((target) => target.isRead === false)
	const ids = targets.map((target) => target.id)
	const batches: Array<{ ids: string[]; isRead: boolean }> = []
	for (let i = 0; i < ids.length; i += MAX_IDS_PER_CALL) {
		batches.push({ ids: ids.slice(i, i + MAX_IDS_PER_CALL), isRead })
	}
	return batches
}
